import { attributeDefRowSchema, attributeDefRowSchemaNoId, bonusDefRowSchema, bonusDefRowSchemaNoId, fileArchiveDefSchema, fileArchiveDefSchemaNoId, organizationDefRowSchema, organizationDefRowSchemaNoId, paramDefRowSchemaNoId, paramDefSchema, profileDefRowSchema, profileDefRowSchemaNoId, territorialIdSchema, bonusParamSchema, timestampSchema, categoryDefRowSchema, categoryDefRowSchemaNoId, userDefRowSchema, userDefRowSchemaNoId, erogantiDefRowSchema, erogantiDefRowSchemaNoId } from '@bonusmap/api-types';
import { z, type ZodSchema } from 'zod';

type SchemaRegistryStructure = Record<string, ZodSchema<any>>;
// [codex] Override campi con messaggi coerenti anche su null/invalid
const bonusDefRowSchemaUI = bonusDefRowSchema.extend({
    organization_id: z
        .number({ required_error: "Deve essere selezionata un'organizzazione", invalid_type_error: "Deve essere selezionata un'organizzazione" })
        .int()
        .min(0, "Deve essere selezionata un'organizzazione"),
    ambito_territoriale: z.preprocess(
        (v) => (v == null ? [] : v),
        z.array(territorialIdSchema).min(1, "Deve essere selezionato almeno un ambito territoriale")
    ),
    title: z
        .string({ required_error: "Il titolo del bonus è obbligatorio", invalid_type_error: "Il titolo del bonus è obbligatorio" })
        .min(1, "Il titolo del bonus è obbligatorio"),
    // [codex] parameters obbligatorio (almeno un parametro o un gruppo)
    parameters: z.array(z.array(bonusParamSchema)).optional()
            // .min(1, "Deve essere impostato almeno un gruppo di parametri")
            // .refine(groups => groups.every(g => g.length > 0), {
            //     message: "Ogni gruppo deve contenere almeno un parametro"
            // }),
            ,
    // [codex] campi non obbligatori ai fini UI
    created_at: timestampSchema.optional(),
    updated_at: timestampSchema.optional()
});
const bonusDefRowSchemaNoIdUI = bonusDefRowSchemaUI.omit({id:true});
let schemaRegistry : SchemaRegistryStructure | null = null;
if(!schemaRegistry) {
    schemaRegistry = {
        // [codex] versione più restrittiva per la UI corrente
        "bonus" : bonusDefRowSchemaUI,
        "profiles": profileDefRowSchema,
        "categories":categoryDefRowSchema,
        "eroganti":erogantiDefRowSchema,
        "personal-attributes":attributeDefRowSchema,
        "organization":organizationDefRowSchema,
        "params":paramDefSchema,
        "files": fileArchiveDefSchema,
        "users": userDefRowSchema.extend({
            // Aggiungo il campo password_hash opzionale per la UI in caso di modifica/creazione
            password_hash: z.string().optional()
        }),
        // [codex]
        // versioni senza id per creazione nuovi record
        // [codex] versione più restrittiva per la UI corrente (no-id)
        "bonus-no-id" : bonusDefRowSchemaNoIdUI,
        "profiles-no-id": profileDefRowSchemaNoId,
        "categories-no-id":categoryDefRowSchemaNoId,
        "eroganti-no-id":erogantiDefRowSchemaNoId,
        "personal-attributes-no-id":attributeDefRowSchemaNoId,
        "organization-no-id":organizationDefRowSchemaNoId,
        "params-no-id":paramDefRowSchemaNoId,
        "files-no-id": fileArchiveDefSchemaNoId,
        "users-no-id": userDefRowSchemaNoId,
    };
}

export default schemaRegistry;
